import React from 'react';
import styled from '@emotion/styled';
import { batch, useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { useTheme } from 'emotion-theming';

import Button from '../../../../shared/_TBComponents/Button';
import Text from '../../../../shared/_TBComponents/Text';
import optimizeImage from '../../../../shared/utils/imageOptimizer';
import { resetEasyJoin } from '../../ducks/registrationActions';

const imageOptimizer = (accountPic) => optimizeImage(
  accountPic,
  {
    resize: {
      fit: 'contain',
      height: 90,
      width: 90,
    },
  },
);

export const AccountPic = styled('div')`
  background-image: ${(props) => `url(${imageOptimizer(props?.accountPic)})`};
  background-size: contain;
  border-radius: 50%;
  height: 90px;
  min-width: 90px;
  width: 90px;
`;

export const AccountPicDummy = styled('div')`
  background-size: contain;
  border-radius: 50%;
  height: 90px;
  min-width: 100px;
  width: 90px;
`;

export const AccountPicWrapper = styled('div')`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const ButtonContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: 45px;
  width: 100%;
`;

export const InteriorDiv = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
`;

const EasyJoinConfirmation = () => {
  const dispatch = useDispatch();
  const theme = useTheme();

  const easyJoinData = useSelector((state) => state.registration.data.easyJoinData);

  const handleConfirm = () => {
    dispatch(push('/signup/registration'));
  };

  const handleTryDifferentCode = () => {
    batch(() => {
      dispatch(resetEasyJoin());
      dispatch(push('/signup/easy-join'));
    });
  };

  return (
    <InteriorDiv>
      <AccountPicWrapper>
        {easyJoinData.accountLogoUrl
          ? <AccountPic accountPic={easyJoinData.accountLogoUrl} />
          : <AccountPicDummy />}
      </AccountPicWrapper>
      <Text styledWrapperProps={{ marginTop: '10px' }}>Account Name</Text>
      <Text styledTextProps={{ fontSize: '22px' }}>{easyJoinData.accountName}</Text>
      <Text styledWrapperProps={{ marginTop: '5px' }}>Description</Text>
      <Text styledTextProps={{ fontSize: '22px' }}>{easyJoinData.description}</Text>
      <ButtonContainer>
        <Button
          bgColor={theme.colors.green}
          fontSize='14px'
          fullWidth
          id='confirm'
          large
          name='confirm'
          noBorder
          onClick={handleConfirm}
          rounded
          txtColor={theme.colors.white}
          type='submit'
          upperCase
        />
        <Button
          fontSize='14px'
          fullWidth
          large
          name='try a different code'
          noBorder
          onClick={handleTryDifferentCode}
          styledWrapperProps={{ marginTop: '15px' }}
          txtColor={theme.colors.lightText[1]}
          type='button'
          upperCase
        />
      </ButtonContainer>
    </InteriorDiv>
  );
};

export default EasyJoinConfirmation;
